import { ZoneId } from '@teetsh/app/src/types/zone';

interface ZoneOption {
  label: string;
  value: ZoneId;
  sublabel?: string;
}

export const zoneOptions: Omit<ZoneOption, 'label'>[] = [
  {
    sublabel:
      'Besançon, Bordeaux, Clermont-Ferrand, Dijon, Grenoble, Limoges, Lyon, Poitiers',
    value: 'zone-a',
  },
  {
    sublabel:
      'Aix-Marseille, Amiens, Caen, Lille, Nancy-Metz, Nantes, Nice, Orléans-Tours, Reims, Rennes, Rouen, Strasbourg',
    value: 'zone-b',
  },
  {
    sublabel: 'Créteil, Montpellier, Paris, Toulouse et Versailles',
    value: 'zone-c',
  },
  {
    sublabel: 'Wallonie-Bruxelles',
    value: 'belgique-wallonie-bruxelles',
  },
  {
    value: 'corse',
  },
  {
    value: 'guadeloupe',
  },
  {
    value: 'guyane',
  },
  {
    value: 'martinique',
  },
  {
    value: 'mayotte',
  },
  {
    value: 'reunion',
  },
  {
    value: 'saint-pierre-et-miquelon',
  },
  {
    value: 'saint-barthelemy',
  },
  {
    value: 'saint-martin',
  },
  {
    value: 'wallis-et-futuna',
  },
  {
    value: 'polynesie-francaise',
  },
  {
    value: 'nouvelle-caledonie',
  },
  {
    value: 'victoria',
  },
  {
    value: 'autre',
  },
];
